import type { OutputData } from '@editorjs/editorjs';

import type { Event } from '../../../../types/DirectusSchema';
import { parseEventDetails } from './parseEventDetails.ts';
import { parseTargetAudiences } from './parseTargetAudiences.ts';

export const parseEvent = (event: Event) => {
  return {
    ...event,
    target_audiences: parseTargetAudiences(event.target_audiences) ?? null,
    event_details: parseEventDetails(event.event_details) ?? null,
    venue: typeof event.venue === 'object' ? event.venue : null,
    category: typeof event.category === 'object' ? event.category : null,
    image: typeof event.image === 'string' ? event.image : null,
    long_description:
      typeof event.long_description === 'object' ? (event.long_description as unknown as OutputData) : null,
  };
};
